













































import { VBTooltip, BTooltip, BFormInput } from 'bootstrap-vue';
import DragIcon from '../DragIcon.vue';

export default {
  name: 'SectionItem',
  components: {
    DragIcon,
    BFormInput,
    BTooltip,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    item: {
      required: true,
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isEditing: false,
      title: '',
      rules: {
        min: 4,
        max: 70,
        message: 'Section name should be between 4 and 70 chars length',
      },
      showTooltip: false,
    };
  },
  methods: {
    nameState() {
      if (this.title.length >= this.rules.min) {
        this.showTooltip = false;
        return true;
      }

      this.showTooltip = true;
      return false;
    },
    editSectionName() {
      this.title = this.item.title;
      this.isEditing = true;
    },
    leaveEdition() {
      this.isEditing = false;
    },
    restoreTitle() {
      this.title = this.item.title;
      this.leaveEdition();
    },
    onBlur() {
      this.setTitle();
    },
    setTitle() {
      if (this.title && this.title.length >= this.rules.min) {
        if (this.item.title !== this.title) {
          this.item.title = this.title;
          this.$emit('changedItem', this.item);
        }
        this.leaveEdition();
        return;
      }

      this.restoreTitle();
    },
    removeSection() {
      this.$emit('removeItem', this.item);
    },
  },
};
